const routes = {
  routes: [
    {
      path: '/',
      redirect: '/views/index'
    },
    {
      path: '/views/index',
      component: (resolve) => require(['@/views/Index'], resolve)
    }
  ]
}
export default routes



// WEBPACK FOOTER //
// ./src/router.js